'use client';
import React from 'react';
import Link from 'next/link';
import { Search } from 'lucide-react';

export default function EmployerQuickSearch() {
  return (
    <Link
      href="/find-help-search-discovery"
      className="flex items-center gap-2 px-4 py-2.5 rounded-xl text-sm font-semibold transition-all duration-150 active:scale-95"
      style={{ background: 'var(--primary)', color: 'white' }}
    >
      <Search size={15} />
      Find a Candidate
    </Link>
  );
}